const url = process.env.REACT_APP_API_URL + "/api/project_indicator";
export default {
  list: ({ projectId }) => `${url}/?project_id=${projectId}`,
};
